export default {
  name: '设置',
  permissionsKey:"JG-SZ",
  icon: 'fa fa-cogs',
  children: {
    baseInfo:{
      name: '基本信息',
      permissionsKey:"JG-SZ-JBXX",
      path: '/setting_manage/base_info',
    },
    applet:{
      name: '学员学习入口',
      permissionsKey:"JG-SZ-XYXXRK",
      path: '/setting_manage/applet',
    },
    adminSetting:{
      name: '管理员设置',
      permissionsKey:"JG-SZ-GLYSZ",
      path: '/setting_manage/admin_setting',
    },
    roleManage:{
      name: '角色设置',
      permissionsKey:"JG-SZ-JSGL",
      path: '/setting_manage/role_manage',
    },
  }
};
